import { render, staticRenderFns } from "./ContentEditBlog.vue?vue&type=template&id=2f3c146a"
import script from "./ContentEditBlog.vue?vue&type=script&lang=js"
export * from "./ContentEditBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports